import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Header from './components/Header';
import Home from './pages/Home';
import Motion from './pages/Motion';
import MotionResult from './pages/MotionResult';
import Motioning from './pages/Motioning';
import Register from './pages/Register';
import { defaultTheme } from './styles/theme';

import logo from 'src/images/logo.png';

import { ThemeProvider } from 'styled-components';

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={defaultTheme}>
        <div className="App">
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Header left={<img src={logo} alt="logo" />} right="" />
                  <Home />
                </>
              }
            />
            <Route path="/register" element={<Register />} />
            <Route path="/motion" element={<Motion />} />
            <Route path="/motioning/:id" element={<Motioning />} />
            <Route path="/motion/result" element={<MotionResult />} />
          </Routes>
        </div>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
